export default "__VITE_PUBLIC_ASSET__a124fb2c__"